import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import {
    resolveAppSiteEntry,
    resolvePublicAppSupportUrl,
    resolvePublicLegalUrl,
    resolvePublicMarketingUrl,
} from "../../../../config/appSiteLinks";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { GroupedRow, systemFont } from "./IOSGroupedList";

function LegalLinkRow({ href, label, last = false }) {
    const { tokens } = useSlidingAppearance();

    return (
        <GroupedRow last={last}>
            <Link
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    color: tokens.text,
                    textDecoration: "none",
                    minHeight: 44,
                    "&:hover": { color: "#059669" },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: systemFont,
                        fontSize: "1rem",
                        fontWeight: 400,
                        color: "inherit",
                    }}
                >
                    {label}
                </Typography>
                <OpenInNewIcon sx={{ fontSize: 18, opacity: 0.45, flexShrink: 0, color: tokens.textMuted }} />
            </Link>
        </GroupedRow>
    );
}

/**
 * Support / Marketing / Privacy / Terms links for mobile app settings (App Store support URL).
 * @param {string} appId — from `APP_SITE_ID` in config/appSiteLinks.js
 */
export default function MobileAppLegalLinks({ appId }) {
    if (!resolveAppSiteEntry(appId)) return null;

    const supportUrl = resolvePublicAppSupportUrl(appId, { platformApp: true });
    const marketingUrl = resolvePublicMarketingUrl(appId, { platformApp: true });
    const privacyUrl = resolvePublicLegalUrl(appId, "privacy", { platformApp: true });
    const termsUrl = resolvePublicLegalUrl(appId, "terms", { platformApp: true });

    return (
        <>
            <LegalLinkRow href={supportUrl} label="Support" />
            <LegalLinkRow href={marketingUrl} label="Marketing" />
            <LegalLinkRow href={privacyUrl} label="Privacy Policy" />
            <LegalLinkRow href={termsUrl} label="Terms of Service" last />
        </>
    );
}
